module.exports = __webpack_public_path__ + "img/Bravia_BZ35L_Smoother movement.6e07e7de.jpg";